import { toast } from 'react-toastify';
import Auth from "./auth"

const API = process.env.REACT_APP_API_URL;

const makeRequest = async (endpoint, params, showError) => {
    const response = {
        error: 'Connection fail',
        data: 'Connection fail'
    };
    try {
        let req = await fetch(API + '/api/' + endpoint, params);
        let text = await req.text();
        let json = text !== '' ? JSON.parse(text) : {};
        response.data = json;
        if (req.status < 200 || req.status > 210) {
            response.error = json.error.message
            if (req.status === 401) {
                Auth.logout();
                window.location.reload();
            }
        } else {
            response.error = ''
        }
    } catch (err) {
        console.error(err);
    }
    if (response.error && showError) {
        toast.error(`${response.error}`);
    }
    return response;
}



export default class Api {
    static postFiles = async (endpoint, formData, showError = true) => {
        return await makeRequest(endpoint, {
            method: 'POST',
            headers: {
                'authorization': `Bearer ${Auth.getToken()}`
            },
            body: formData
        }, showError);
    }

    static post = async (endpoint, params, showError = true) => {
        return await makeRequest(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${Auth.getToken()}`
            },
            body: JSON.stringify(params)
        }, showError);
    }

    static get = async (endpoint, params = '', showError = true) => {
        if (params) {
            params = '?filter=' + encodeURI(JSON.stringify(params));
        }
        return await makeRequest(endpoint + params, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${Auth.getToken()}`
            },
        }, showError);
    }

    static patch = async (endpoint, params, showError = true) => {
        return await makeRequest(endpoint, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${Auth.getToken()}`
            },
            body: JSON.stringify(params)
        }, showError);
    }

    static del = async (endpoint, showError = true) => {
        return await makeRequest(endpoint, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${Auth.getToken()}`
            },
        }, showError);
    }

    static download = async (endpoint, showError = true) => {
        const response = {
            error: 'Connection fail',
            data: null
        };
        try {
            let req = await fetch(API + '/api/' + endpoint, {
                method: 'GET',
                headers: {
                    'authorization': `Bearer ${Auth.getToken()}`
                },
            });
            if (req.status < 200 || req.status > 210) {
                response.error = 'Error fetching file';
                if (req.status === 401) {
                    Auth.logout();
                    window.location.reload();
                }
            } else {
                response.data = await req.blob();
                response.error = '';
            }
        } catch (err) {
            console.error(err);
        }
        if (response.error && showError) {
            toast.error(`${response.error}`);
        }
        return response.data;
    }

    static getURL = () => API
}